import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import type { ReactElement, ReactNode } from 'react';

/** Один провайдер на приложение: соседние подсказки открываются без задержки. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return <BaseTooltip.Provider delay={0}>{children}</BaseTooltip.Provider>;
}

interface TooltipProps {
  content: ReactNode;
  /** Элемент-триггер; должен принимать ref и обработчики (кнопка, ссылка). */
  children: ReactElement;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

/**
 * Тёмная подсказка, как у панели команд прототипа. Показывается и на выключенной кнопке
 * (если та фокусируема — `focusableWhenDisabled`): именно подсказка объясняет, почему контрол выключен.
 */
export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={10}>
          <BaseTooltip.Popup className="max-w-64 rounded-md bg-tooltip px-2.5 py-2 text-xs leading-none text-tooltip-foreground shadow-tip transition-opacity data-[ending-style]:opacity-0 data-[starting-style]:opacity-0">
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
